/* LB — contraste del header sobre la imagen de producto.
   24-09-2026 (Ayoub): el detector mira SOLO la zona de la imagen que queda detrás del logo (antes miraba toda la franja
   superior y fallaba cuando el fondo era blanco pero justo detrás del logo la prenda era oscura). */
(function () {
  'use strict';

  var gallery;
  var lastKey = '';
  var sampleToken = 0;
  var settleTimer;

  function setContrast(useDarkInk) {
    document.body.classList.toggle('lb-header-on-light', useDarkInk);
    document.body.classList.toggle('lb-header-on-dark', !useDarkInk);
  }

  function activeImage() {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    var center = gallery.scrollLeft + gallery.clientWidth / 2;
    var active = null;
    var bestDistance = Number.POSITIVE_INFINITY;
    slides.forEach(function (slide) {
      if (slide.hidden || slide.offsetParent === null) return;
      var distance = Math.abs(center - (slide.offsetLeft + slide.offsetWidth / 2));
      if (distance < bestDistance) { active = slide; bestDistance = distance; }
    });
    return active && active.querySelector('img');
  }

  function relativeLuminance(r, g, b) {
    function linear(value) {
      value /= 255;
      return value <= 0.04045 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * linear(r) + 0.7152 * linear(g) + 0.0722 * linear(b);
  }

  /* Zona a analizar, en fracciones (0-1) de la imagen mostrada: el rectángulo del logo con un pequeño margen. */
  function logoZone(img) {
    var logo = document.querySelector('.lb-header-logo-center');
    var ir = img.getBoundingClientRect();
    if (!logo || !ir.width || !ir.height) return null;
    var lr = logo.getBoundingClientRect();
    var pad = 6;
    var x0 = (lr.left - pad - ir.left) / ir.width;
    var x1 = (lr.right + pad - ir.left) / ir.width;
    var y0 = (lr.top - pad - ir.top) / ir.height;
    var y1 = (lr.bottom + pad - ir.top) / ir.height;
    x0 = Math.max(0, Math.min(1, x0)); x1 = Math.max(0, Math.min(1, x1));
    y0 = Math.max(0, Math.min(1, y0)); y1 = Math.max(0, Math.min(1, y1));
    if (x1 - x0 < 0.05 || y1 - y0 < 0.02) return null; // el logo no está sobre la imagen
    return { x0: x0, x1: x1, y0: y0, y1: y1 };
  }

  function inspectImage(img) {
    if (!img) { setContrast(false); return; }
    var source = img.currentSrc || img.src;
    if (!source) return;
    var zone = logoZone(img);
    var key = source + '|' + (zone ? [zone.x0, zone.x1, zone.y0, zone.y1].map(function (v) { return v.toFixed(2); }).join(',') : 'top');
    if (key === lastKey) return;
    lastKey = key;
    var token = ++sampleToken;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';

    probe.onload = function () {
      if (token !== sampleToken) return;
      try {
        var W = 120, H = 120;
        var canvas = document.createElement('canvas');
        canvas.width = W; canvas.height = H;
        var context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(probe, 0, 0, W, H);
        var pixels = context.getImageData(0, 0, W, H).data;
        var luminances = [];
        var z = zone || { x0: 0.02, x1: 0.98, y0: 0.01, y1: 0.18 };
        var xs = Math.floor(z.x0 * W), xe = Math.ceil(z.x1 * W), ys = Math.floor(z.y0 * H), ye = Math.ceil(z.y1 * H);
        for (var y = ys; y < ye; y++) {
          for (var x = xs; x < xe; x++) {
            var index = (y * W + x) * 4;
            if (pixels[index + 3] < 220) continue;
            luminances.push(relativeLuminance(pixels[index], pixels[index + 1], pixels[index + 2]));
          }
        }
        if (!luminances.length) { setContrast(false); return; }
        luminances.sort(function (a, b) { return a - b; });
        var median = luminances[Math.floor(luminances.length / 2)];
        var average = luminances.reduce(function (sum, value) { return sum + value; }, 0) / luminances.length;
        var brightShare = luminances.filter(function (value) { return value > 0.52; }).length / luminances.length;
        // Fondo claro detrás del logo -> logo e iconos en negro; fondo oscuro -> en blanco.
        setContrast(median > 0.42 || (average > 0.48 && brightShare > 0.5));
      } catch (error) {
        setContrast(false);
      }
    };
    probe.onerror = function () { if (token === sampleToken) setContrast(false); };
    probe.src = source;
  }

  function refresh() {
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(function () { inspectImage(activeImage()); }, 90);
  }

  function resetAndRefresh() {
    lastKey = '';
    window.setTimeout(refresh, 80);
    window.setTimeout(refresh, 420);
  }

  function init() {
    if (!document.body.classList.contains('lb-product')) return;
    gallery = document.querySelector('.product__media-list');
    if (!gallery || gallery.dataset.lbHeaderContrastReady === 'true') return;
    gallery.dataset.lbHeaderContrastReady = 'true';
    gallery.addEventListener('scroll', refresh, { passive: true });
    gallery.addEventListener('scrollend', refresh, { passive: true });
    window.addEventListener('resize', resetAndRefresh, { passive: true });
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest('.lb-product-option--color')) resetAndRefresh();
    });
    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest('.lb-product-option--color label')) resetAndRefresh();
    });
    window.addEventListener('load', resetAndRefresh, { once: true });
    refresh();
    window.setTimeout(resetAndRefresh, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
